import React, { useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../context/Authcontext';
import HeaderSign from "../components/signupHeader";
import { resendEmailVerification} from '../api/auth/auth';
// import { getAuthToken, setAuthToken} from '../utils/auth'
const Login = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loginError,setLoginError]=useState('');
  const { isAuthenticated ,login} = useAuth();
  const [ resendVerificationButton, setResendVerificationButton ]=useState(false);
  const [ reminder , setReminder]=useState("");
  const navigate = useNavigate();

  if (isAuthenticated){
    navigate('/', { replace: true });
    return null; 
  }

  const validateEmail = (value) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!value) return 'Email is required';
    if (!emailRegex.test(value)) return 'Please enter a valid email';
    return '';
  };

  const validatePassword = (value) => {
    if (!value) return 'Password is required';
    return '';
  };

  const handleEmailBlur = (e) => {
    setEmailError(validateEmail(e.target.value));
  };

  const handlePasswordBlur = (e) => {
    setPasswordError(validatePassword(e.target.value));
  };
  const handleSubmitEmailVerif=async ()=>{
    console.log(email);
    setLoginError("")
    setReminder("");
    if (validateEmail()!==''){
      try {
        await resendEmailVerification({ email: email });
        setReminder("Email has been sent check you inbox ! ");
      }catch(error){
        setLoginError("Email not found !")
      }
      
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailErr = validateEmail(email);
    const passwordErr = validatePassword(password);
    setEmailError(emailErr);
    setPasswordError(passwordErr);

    if (!emailErr && !passwordErr) {
      try {
        const token =await login(email, password);
        navigate('/', { replace: true });
        return null; 
      } catch (error) {
        setLoginError(error.message);
        if (error.message === 'Email not verified !'){
          setResendVerificationButton(true);
        }
        console.error('Login error:', error.message);
      }
    }
  };
 const handleSignup = ()=>{
  navigate('/signup', { replace: true }); }
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleForgotPassword = () => {
    navigate("/reset-password" , {replace : true});
    // TODO: Implement password reset
  };

  return (
    <div className="min-h-screen bg-gray-50">
       <HeaderSign />
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Log In</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              id="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={handleEmailBlur}
              className={`w-full text-sm text-gray-700 border ${
                emailError ? 'border-red-500' : 'border-gray-300'
              } rounded-md py-2 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500`}
            />
            {emailError && <p className="text-red-500 text-xs mt-1">{emailError}</p>}
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={handlePasswordBlur}
                className={`w-full text-sm text-gray-700 border ${
                  passwordError ? 'border-red-500' : 'border-gray-300'
                } rounded-md py-2 px-3 pr-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500`}
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700 focus:outline-none"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
            {passwordError && <p className="text-red-500 text-xs mt-1">{passwordError}</p>}
            <div className="flex justify-between mt-1">
                <button
                  type="button"
                  onClick={handleForgotPassword}
                  className="text-sm text-blue-600 hover:text-blue-800 hover:underline focus:outline-none"
                >
                  Forgot password?
                </button>
                <button
                  type="button"
                  onClick={handleSignup}
                  className="text-sm text-blue-600 hover:text-blue-800 hover:underline focus:outline-none"
                >
                  Sign Up?
                </button>
              </div>
          </div>
            {!resendVerificationButton && (<button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 px-4 rounded-md font-semibold text-sm hover:bg-blue-700 transition-colors"
            >
              Log In
            </button>)
     
          }
      
            {resendVerificationButton && (
              <button
                type="button"
                onClick={handleSubmitEmailVerif}
                className="w-full bg-blue-600 text-white py-2 px-4 rounded-md font-semibold text-sm hover:bg-blue-700 transition-colors"
              >
                Resend Verification
              </button>
            )}
          {reminder && <p className="text-green-500 text-xs mt-1">{reminder}</p>}
          {loginError && <p className="text-red-500 text-xs mt-1">{loginError}</p>}
        </form>
      </div>
    </div>
    </div>
  );
};

export default Login;